import {
  Directive,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { assert } from '@sama/js-core';
import { ViewContainerMappingService } from './view-container-mapping.service';

@Directive({
  selector: '[h3ViewContainer]',
  standalone: false,
})
export class ViewContainerDirective implements OnInit, OnDestroy {
  @Input({ required: true }) containerId!: string;
  @Input() viewId?: string;

  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<any>, { optional: true });
  private viewContainerMappingService = inject(ViewContainerMappingService);

  ngOnInit() {
    this.viewContainerMappingService.addContainer(
      this.containerId,
      this.viewContainer,
    );

    assert(
      !!this.viewId === !!this.templateRef,
      'viewId and templateRef must be used together',
    );

    if (this.viewId) {
      this.viewContainerMappingService.addView(
        this.viewId,
        this.viewContainer.createEmbeddedView(this.templateRef!),
      );
      this.viewContainerMappingService.updateViewContainerMapping(
        this.viewId,
        this.containerId,
      );
    }
  }

  ngOnDestroy() {
    this.viewContainerMappingService.cleanUp(this.containerId, this.viewId);
  }
}
